module.exports = __webpack_public_path__ + "static/img/K1.c25f217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/K1.jpg
// module id = rEWj
// module chunks = 1